import { render } from "./ExperienceHubPrincipal.vue?vue&type=template&id=20a38c61"
import script from "./ExperienceHubPrincipal.vue?vue&type=script&lang=js"
export * from "./ExperienceHubPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__